/* dtf-page-motion.js — motion for collection + PDP (loaded only on those templates).
   Guards: prefers-reduced-motion off; IntersectionObserver required; 1.8s safety reveal;
   never hides LCP product image or the buy form. Re-scans for async product recommendations. */
(function(){
  try{
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var css = [
      '.dtfc-card{transition:transform .28s cubic-bezier(.2,.7,.2,1),box-shadow .28s ease}',
      '.dtfc-card__img{overflow:hidden}',
      '.dtfc-card__img img{transition:transform .45s cubic-bezier(.2,.7,.2,1)}',
      '.cc-product-recommendations .js-prod-link{transition:transform .28s cubic-bezier(.2,.7,.2,1)}',
      '@media (hover:hover){',
        '.dtfc-card:hover{transform:translateY(-5px);box-shadow:0 12px 26px rgba(20,20,20,.10)}',
        '.dtfc-card:hover .dtfc-card__img img{transform:scale(1.07)}',
        '.cc-product-recommendations .js-prod-link:hover{transform:translateY(-4px)}',
      '}'
    ];
    if(!reduce){
      css.push('.dtf-rv{opacity:0;transform:translateY(20px);transition:opacity .6s ease,transform .65s cubic-bezier(.2,.7,.2,1)}');
      css.push('.dtf-rv.dtf-in{opacity:1;transform:none}');
    }
    var st=document.createElement('style'); st.textContent=css.join(''); document.head.appendChild(st);
    if(reduce || !('IntersectionObserver' in window)) return;

    var io=new IntersectionObserver(function(ents){ ents.forEach(function(e){ if(e.isIntersecting){ var el=e.target,d=(el.__i||0)*70; setTimeout(function(){el.classList.add('dtf-in');},d); io.unobserve(el);} }); }, {threshold:0.12, rootMargin:'0px 0px -6% 0px'});

    function reveal(el, i){
      if(el.__rv) return; el.__rv=1; el.classList.add('dtf-rv'); el.__i=(i||0)%6; io.observe(el);
      setTimeout(function(){ el.classList.add('dtf-in'); }, 1800);
    }
    function scan(){
      var vh=window.innerHeight;
      [].slice.call(document.querySelectorAll('.dtfc-grid .dtfc-card')).forEach(function(c,i){ if(c.getBoundingClientRect().top > vh*0.85) reveal(c,i); });
      [].slice.call(document.querySelectorAll('.cc-product-recommendations .js-prod-link')).forEach(function(c,i){ reveal(c,i); });
    }
    scan();
    setTimeout(scan, 1200);   // catch async-loaded product recommendations
    setTimeout(scan, 2600);
  }catch(e){}
})();
